import React from "react";
import { Cascader as AntdCascader } from "antd";

const Cascader = ({
	defaultValue,
	dispatch,
	name,
	questionId,
	tree,
	placeholder,
	dataType,
	isNew,
	...otherProps
}) => {
	const [answerAdded, answerEdited] = dispatch;
	//need to serialise the value before sending to redux, as the data type is array
	const onChange = (value) => {
		let data = {
			questionId: questionId,
			value: value.join("|"),
			id: name,
			dataType: dataType,
		};
		if (defaultValue) answerEdited(data);
		else answerAdded(data);
	};

	function filter(inputValue, path) {
		return path.some(
			(option) =>
				option.title.toLowerCase().indexOf(inputValue.toLowerCase()) >
				-1
		);
	}

	//need to deserialise the value before consuming it on the component
	const deserialisedValue = defaultValue ? defaultValue.split("|") : null;

	return (
		<AntdCascader
			style={{ width: "100%" }}
			fieldNames={{
				label: "title",
				value: "value",
				children: "children",
			}}
			onChange={onChange}
			value={deserialisedValue}
			options={tree}
			placeholder={placeholder || "Search by description"}
			showSearch={{ filter }}
			{...otherProps}
		/>
	);
};

export default Cascader;
